export default "__VITE_ASSET__BqSHe6OC__"